import { difference } from 'lodash';
import { flow, reject, map, takeRight, concat } from 'lodash/fp';
import { NotificationState } from '@mews-commander/legacy-data-structures';
import { NOTIFICATION_MARKED_SEEN, NOTIFICATIONS_FETCHED, NOTIFICATION_MARKED_PENDING } from '../actions/common';
import { KNOWN_NOTIFICATIONS_CAPACITY } from '../constants';
import { isSeen } from '../utils/isSeen';

export function notifications(state = {}, action: $TSFixMe) {
    switch (action.type) {
        case NOTIFICATIONS_FETCHED:
            return {
                ...state,
                ...action.payload,
            };
        case NOTIFICATION_MARKED_SEEN:
            return replaceState(state, action.payload, NotificationState.Seen);
        case NOTIFICATION_MARKED_PENDING:
            return replaceState(state, action.payload, NotificationState.Pending);
        default:
            return state;
    }
}

// @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
const replaceState = (state, id, newState) => ({
    ...state,

    [id]: {
        ...state[id],
        state: newState.value,
    },
});

const unseenNotificationsIds = flow(
    reject(isSeen),
    map((n) => n.id)
);

function getCombinedIds(oldItems: $TSFixMe, newItems: $TSFixMe) {
    const diff = difference(newItems, oldItems);
    return flow(
        takeRight(KNOWN_NOTIFICATIONS_CAPACITY - diff.length),
        (concat as $TSFixMe).convert({ rearg: true })(diff)
    )(oldItems);
}

export function knownNotifications(state = [], action: $TSFixMe) {
    switch (action.type) {
        case NOTIFICATIONS_FETCHED:
            return getCombinedIds(state, unseenNotificationsIds(action.payload));
        case NOTIFICATION_MARKED_PENDING:
            return getCombinedIds(state, [action.payload]);
        default:
            return state;
    }
}
